<template>
  <div class="diagnostics">
    <div class="row align-items-center justify-content-between">
      <div class="col-auto"><h2 class="profile__header">{{ $t('visits.diagnostics') }}</h2></div>
      <div class="col-auto">
        <router-link :to="{name:'profile.visits.past.diagnostics.files'}" class="btn-gray-border w-auto m-0">
          {{ $t('visits.diagnostics_files') }}
        </router-link>
      </div>
    </div>


    <div class="row">
      <div class="diagnostics-past col-md-11 visits__items">
        <div v-if="inLoading === true" class="text-center mt-5 d-flex justify-content-center">
          <b-spinner
              variant="primary"
          ></b-spinner>
        </div>
        <template v-if="diagnosticsPast.length === 0 && inLoading === false">
          <div class="not-found row mt-5">
            <div class="col-3 d-flex justify-content-end">
              <img src="~@/assets/images/zero-illu-01.svg" alt="">
            </div>
            <div class="col-7">
              <div class="mb-3" v-html="$t('diagnostic.empty.text')">
              </div>

              <router-link :to="{name:'profile.order.find-doctor'}" class="btn w-auto">
                {{
                  $t('diagnostic.empty.button')
                }}
              </router-link>
            </div>
          </div>
        </template>

        <div class="visits__item row"
             v-if="inLoading === false"
             v-for="diagnosticVisitPast in diagnosticsPast"
             :class='{ "read": diagnosticVisitPast.read }'>
          <i class="fa fa-check" aria-hidden="true"></i>

          <div class="date col-3">
            {{ formatDate(diagnosticVisitPast.date_time) }}
            <span>{{ formatTime(diagnosticVisitPast.date_time) }}</span>
          </div>

          <div class="col-5">
            <div class="text">{{ diagnosticVisitPast.name }}</div>
          </div>
          <div class="text col-2">
            {{ getClinicName(diagnosticVisitPast) }}
          </div>

          <div class="col-2 d-flex">
            <button class="icon__info" @click="openDocumentModal(diagnosticVisitPast)"></button>

            <button class="btn btn-link-clear btn-icon"
                    v-if="diagnosticVisitPast.service_type.can_be_ordered"
                    @click="reOrder(diagnosticVisitPast)">
              <i class="fa fa-repeat" aria-hidden="true"></i>
            </button>
          </div>


          <div class="delimiter w-100"></div>
        </div>

        <b-modal ref="documentModal" centered size="lg" hide-footer :title="$t('common.docs')">
          <div class="loading w-100 d-flex justify-content-center" v-if="selectedVisitPastContentLoading">
            <b-spinner
                variant="primary"
            ></b-spinner>
          </div>
          <iframe class="content w-100 h-auto" style="min-height: 500px" ref="selectedVisitPastDocument"></iframe>

          <div class="mt-3">
            <button class="btn-blue mr-1" v-if="selectedVisitPastContent" @click="downloadDocument()">
              {{ $t('buttons.download') }}
            </button>
            <button class="btn-blue" @click="hideDocumentModal()">{{ $t('buttons.hide') }}</button>
          </div>
        </b-modal>

        <b-modal ref="reorderModal" centered size="md" hide-footer :title="$t('common.notification')">
          <div class="content">
            {{ $t('diagnostic.registration_diagnostic_not_possible') }}<br>
            {{ $t('diagnostic.from_booking_call') }}<br>
            <a href="tel:+380487300030">
              +38 (048) 730-00-30
            </a>
          </div>

          <div class="mt-3">
            <button class="btn-blue" @click="hideReorderModal()">{{ $t('buttons.hide') }}</button>
          </div>
        </b-modal>
        <error-modal @closeModal="closeModal()" v-model="showErrorModal" :errorText="errorText"/>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import fileSave from '@/helpers/fileSave';
import config from '@/helpers/configDateFormats';
import ErrorModal from "@/components/ErrorModal";

export default {
  name: 'diagnostics-past',
  data() {
    return {
      selectedVisitPast: null,
      selectedVisitPastContentLoading: false,
      selectedVisitPastContent: null,
      showErrorModal: false,
      errorText: '',
    };
  },
  computed: {
    ...mapGetters([
      'diagnosticsPast',
      'clinics',
      'isConsultationsInLoading',
      'isDiagnosticsInLoading',
    ]),

    inLoading() {
      return this.isConsultationsInLoading || this.isDiagnosticsInLoading;
    },
  },
  methods: {
    closeModal() {
      this.showErrorModal = false
    },
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    },
    reOrder(diagnosticVisitPast) {
      if (diagnosticVisitPast.service_type.id && diagnosticVisitPast.clinic && diagnosticVisitPast.service_type.diagnostic_type_id) {
        let query = {
          diagnostic_id: diagnosticVisitPast.service_type.id,
          diagnostic_type_id: diagnosticVisitPast.service_type.diagnostic_type_id,
          clinic_id: diagnosticVisitPast.clinic.id,
        };

        this.$router.push({
          name: 'profile.order.choose-diagnostic-time-table',
          query,
        })
      } else {
        this.$refs.reorderModal.show();
      }
    },
    hideReorderModal() {
      this.$refs.reorderModal.hide();
    },
    getClinicName(visit) {
      let visitClinic = this.clinics.filter((item) => item.id === visit.clinic.id)
      if (visitClinic.length > 0) {
        return visitClinic[0].address
      }
      return ''
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    documentModalOpen() {
      this.$refs.documentModal.show();
    },
    documentModalHide() {
      this.$refs.documentModal.hide();
      this.selectedVisitPastContent = null;
    },
    openDocumentModal(visitPast) {
      this.selectedVisitPastContent = null;
      this.selectedVisitPastContentLoading = true;

      if (this.$refs.selectedVisitPastDocument) {
        this.$refs.selectedVisitPastDocument.src = '';
      }

      this.selectedVisitPast = visitPast;
      this.documentModalOpen()
      this.$store
          .dispatch('getVisitDocument', {visit_id: visitPast.id})
          .then(content => {

            this.selectedVisitPastContent = content;
            this.selectedVisitPastContentLoading = false;
            let byteCharacters = atob(content.data);
            let byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], {type: 'application/pdf;base64'});
            this.$refs.selectedVisitPastDocument.src = URL.createObjectURL(file);
            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']})
          })
          .catch(err => {
            this.documentModalHide();
            if (err.response.data.code === 'get-document-file-exception') {
              this.showErrorModal = true
              this.errorText = this.$t('errors.document')

            }
          })
    },
    downloadDocument() {
      if (this.selectedVisitPastContent) {
        let byteCharacters = atob(this.selectedVisitPastContent.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        fileSave({
          blob: byteArray,
          type: 'application/pdf',
          name: this.selectedVisitPast.name,
        });
      }
    },
  },
  components: {
    ErrorModal
  }
}
</script>

<style lang="scss">
.diagnostics-past {
  & > .not-found {
    margin-left: 0;
    margin-right: 0;
    border-radius: 5px;
    background-color: #f2f8fa;

    & .row {
      background-color: #f2f8fa;
    }

    & > div:first-child {
      & > img {
        max-width: 100%;
      }
    }
  }

  & > .visits__item:last-child .delimiter {
    display: none;
  }
}
</style>
